export const inspection = {
  criticalItem: "关键项",
  customGroup: "自定义分组",
  customItem: "自定义项目",
  customSection: "自定义小节",
  deleteInformation:
    "请为下面列出的车型选择其他点检模板，或者选择“无”来删除点检模板功能，以后需要的时候再选择点检模板。",
  deleteInspectionGroupTip: "点检分组“{0}”将被删除。确定要继续吗？",
  deleteInspectionItemTip: "点检项“{0}”将被删除。确定要继续吗？",
  deleteInspectionSectionTip: "点检小节“{0}”将被删除。确定要继续吗？",
  deleteNotUsedTip: "点检模板{0}将被删除。确定要继续吗？",
  deleteUsedTip: "确认删除点检模板{0}并应用更改？",
  editTemplate: "编辑点检模板",
  failedDeleteInspectionTemplateUsed: "删除失败，点检模板已被使用。",
  failedToDeleteGroupNotEmpty: "删除失败，请先删除此分组的内容。",
  failedToDeleteItemUsed: "删除失败，此项目已被其他模板使用。",
  failedToDeleteSectionNotEmpty: "删除失败，请先删除此小节的内容。",
  failedToSaveGroupNameAlreadyExist: "保存失败，此分组已存在。",
  failedToSaveItemNameAlreadyExist: "保存失败，此项目已存在。",
  failedToSaveTemplateEmpty: "保存失败，点检模板需要至少包含一个点检项目。",
  failedToSaveTemplateNameAlreadyExist: "保存失败，此模板已存在。",
  failedToSaveSectionNameAlreadyExist: "保存失败，此小节已存在。",
  inspectionItemUsedUpdateItAnyway: "此字段被其他模板使用。确定继续更新吗？",
  InspectionTemplateDeletion: "删除点检模板",
  InspectionTemplateUsedUpdateItAnyway: "确认更改",
  modelList: "型号列表",
  newTemplate: "新建点检模板",
  pleaseInputGroupName: "请输入分组名称",
  pleaseInputItemName: "请输入项目名称",
  pleaseInputTemplateName: "请输入点检模板名称",
  pleaseInputSectionName: "请输入小节名称",
  selectAnInspectionTemplate: "请选择点检模板",
  tipsTemplateEmpty: "至少需要包含一个点检项目。",
};
